import { memo } from "react";
import { useTranslation } from "react-i18next";
import { originName as origin_name } from "@/utils/origin-name";
interface Prop {
  variant: "withText" | "default";
  href?: string;
  isDefault?: boolean;
  isMobile?: boolean;
}

function Logo({ variant, href = "/", isDefault = false, isMobile }: Prop) {
  const { i18n } = useTranslation();
  if (
    origin_name === "bioarc" ||
    origin_name === "isaimed" ||
    origin_name === "abzums" ||
    isDefault
  ) {
    const logoUrlFa = "/assets/logo/logo-fa.svg";
    const logoUrlFaDark = "/assets/logo/logo-fa-w.svg";
    const logoUrlEn = "/assets/logo/logo.svg";
    const logoUrlEnDark = "/assets/logo/logo-w.svg";
    if (isMobile) {
      const lightSrc = "/assets/logo/default-light.svg";
      const darkSrc = "/assets/logo/default-dark.svg";
      return (
        <a href={href} className="inline-block">
          <img
            src={lightSrc}
            alt="Logo"
            className="block dark:hidden w-16 h-auto"
          />
          <img
            src={darkSrc}
            alt="Logo"
            className="hidden dark:block w-16 h-auto"
          />
        </a>
      );
    }
    if (variant === "withText") {
      const lightSrc = i18n.language === "fa" ? logoUrlFa : logoUrlEn;
      const darkSrc = i18n.language === "fa" ? logoUrlFaDark : logoUrlEnDark;
      return (
        <a href={href} className="inline-block">
          <img
            src={lightSrc}
            alt="Logo"
            className="block dark:hidden w-32 h-auto"
          />
          <img
            src={darkSrc}
            alt="Logo"
            className="hidden dark:block w-32 h-auto"
          />
        </a>
      );
    } else {
      const lightSrc = "/assets/logo/default-light.svg";
      const darkSrc = "/assets/logo/default-dark.svg";
      return (
        <a href={href} className="inline-block">
          <img
            src={lightSrc}
            alt="Logo"
            className="block dark:hidden w-32 h-auto"
          />
          <img
            src={darkSrc}
            alt="Logo"
            className="hidden dark:block w-32 h-auto"
          />
        </a>
      );
    }
  }
  if (origin_name === "faranor") {
    const lightSrc = "/assets/logo/faranor-logo.svg";
    return (
      <a href={href} className="inline-block">
        <img src={lightSrc} alt="Logo" className="block w-32 h-auto" />
      </a>
    );
  }
  if (origin_name === "rhc") {
    const lightSrc = "/assets/logo/rajaei.svg";
    return (
      <a href={href} className="inline-block ">
        <img src={lightSrc} alt="Logo" className="block w-52 h-auto" />
      </a>
    );
  }
  if (origin_name === "iums") {
    const lightSrc = "/assets/logo/IUMS.png";
    return (
      <a href={href} className="inline-block ">
        <img src={lightSrc} alt="Logo" className="block w-56 h-auto" />
      </a>
    );
  }
  if (origin_name === "behdashttums" || origin_name === "tums") {
    const lightSrc = "/assets/logo/TUMS.png";
    return (
      <a href={href} className="inline-block ">
        <img src={lightSrc} alt="Logo" className="block w-20 h-auto" />
      </a>
    );
  }
  if (origin_name === "thcb") {
    const lightSrc = "/assets/logo/thcb.webp";
    return (
      <a href={href} className="inline-block ">
        <img src={lightSrc} alt="Logo" className="block w-20 h-auto" />
      </a>
    );
  }
}

export default memo(Logo);
